export default function translate(i18n, propriete) {
  let libellePropriete = propriete;
  if (propriete.indexOf('lignesCommande') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'Libelle') {
      return i18n.t('validationCommande.name.libelleLigneCommande');
    }
    if (libellePropriete === 'Quantite') {
      return i18n.t('validationCommande.name.quantiteLigneCommande');
    }
    if (libellePropriete === 'PrixUnitaire') {
      return i18n.t('validationCommande.name.prixUnitaireLigneCommande');
    }
    if (libellePropriete === 'Remise') {
      return i18n.t('validationCommande.name.remiseLigneCommande');
    }
    if (libellePropriete === 'TauxTva') {
      return {
        message: 'validationCommande.name.tauxTvaLigneCommande',
      };
    }

    if (libellePropriete.indexOf('LignesCommande') === 0) {
      libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
      if (libellePropriete === 'Quantite') {
        return i18n.t('validationCommande.name.quantiteLigneCommande');
      }
      if (libellePropriete === 'PrixUnitaire') {
        return i18n.t('validationCommande.name.prixUnitaireLigneCommande');
      }
      if (libellePropriete === 'Remise') {
        return i18n.t('validationCommande.name.remiseLigneCommande');
      }
    }
    return libellePropriete;
  }

  if (propriete === 'dateDevisCommande') {
    return i18n.t('validationCommande.name.dateSignature');
  }

  if (propriete === 'dateValidite') {
    return {
      message: 'validationCommande.name.dateValidite',
    };
  }

  if (propriete.indexOf('echeanciers') !== -1) {
    libellePropriete = libellePropriete.slice(libellePropriete.lastIndexOf('.') + 1);
    if (libellePropriete === 'dateDebut') {
      return 'echeancierFacturation.messages.errors.required.dateDebutEcheance';
    }
    if (libellePropriete === 'dateFin') {
      return 'echeancierFacturation.messages.errors.required.dateFinEcheance';
    }
    if (libellePropriete === 'datePrevisionnelleFacturation') {
      return 'echeancierFacturation.messages.errors.required.dateFinPremiereEcheance';
    }
    if (libellePropriete === 'tiersId') {
      return 'echeancierFacturation.messages.errors.required.payeur';
    }
    if (libellePropriete === 'montant') {
      return 'echeancierFacturation.messages.errors.required.montant';
    }
    if (libellePropriete === 'CommentaireFacturation') {
      return i18n.t('echeancierFacturation.messages.errors.required.commentaireFacturation');
    }
  }

  if (propriete === 'commentaireInterne') {
    return i18n.t('validationCommande.name.commentaireInterne');
  }

  return propriete;
}
